export function companyDomain(company: {
	domain?: string | null
	domains?: readonly string[] | null
}): string | null {
	return company.domains?.[0] || company.domain || null
}
